import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\ReincludeCommissionDocumentController::__invoke
* @see app/Http/Controllers/CommissionNote/ReincludeCommissionDocumentController.php
* @route '/api/commission-note-document/{invoice}/reinclude'
*/
const ReincludeCommissionDocumentController = (args: { invoice: string | number } | [invoice: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ReincludeCommissionDocumentController.url(args, options),
    method: 'post',
})

ReincludeCommissionDocumentController.definition = {
    methods: ["post"],
    url: '/api/commission-note-document/{invoice}/reinclude',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\CommissionNote\ReincludeCommissionDocumentController::__invoke
* @see app/Http/Controllers/CommissionNote/ReincludeCommissionDocumentController.php
* @route '/api/commission-note-document/{invoice}/reinclude'
*/
ReincludeCommissionDocumentController.url = (args: { invoice: string | number } | [invoice: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: args.invoice,
    }

    return ReincludeCommissionDocumentController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\ReincludeCommissionDocumentController::__invoke
* @see app/Http/Controllers/CommissionNote/ReincludeCommissionDocumentController.php
* @route '/api/commission-note-document/{invoice}/reinclude'
*/
ReincludeCommissionDocumentController.post = (args: { invoice: string | number } | [invoice: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ReincludeCommissionDocumentController.url(args, options),
    method: 'post',
})

export default ReincludeCommissionDocumentController